import React from "react";

const ChartTabs = (props) => {
  let { active, list, handelPieTab } = props;
  return (
    <div>
      <div className="flex items-center mb-3">
        <div className="inline-flex rounded-md shadow-sm" role="group">
          {list &&
            list.map((item, i) => {
              return (
                <div key={i}>
                  {i === 0 ? (
                    <button
                      onClick={() => handelPieTab(item.key)}
                      type="button"
                      className={`inline-flex items-center border-t-2 border-b-2 border-[#FEBB12]  py-2 px-4 text-sm font-medium  rounded-l-lg border-2 ${
                        active == item.key
                          ? "bg-[#FEBB12] text-[white]"
                          : "bg-[white] text-[#333333]"
                      } `}
                    >
                      {item.name}
                    </button>
                  ) : i === 1 ? (
                    <button
                      onClick={() => handelPieTab(item.key)}
                      type="button"
                      className={`inline-flex  items-center py-2 px-4 ${
                        active == item.key
                          ? "bg-[#FEBB12] text-[white]"
                          : "bg-[white] text-[#333333]"
                      } text-sm font-medium  border-t-2 border-b-2 border-[#FEBB12]`}
                    >
                      {item.name}
                    </button>
                  ) : i === 2 ? (
                    <button
                      //
                      onClick={() => handelPieTab(item.key)}
                      type="button"
                      className={`inline-flex items-center border-t-2 border-b-2 border-[#FEBB12]  py-2 px-4 text-sm font-medium  rounded-r-lg border-2 ${
                        active == item.key
                          ? "bg-[#FEBB12] text-[white]"
                          : "bg-[white] text-[#333333]"
                      } `}
                    >
                      {item.name}
                    </button>
                  ) : null}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default ChartTabs;
